class SettingsContainer {
  constructor(
    $q,
    $location,
    appErrorHandler,
    appEvents,
    appSession,
    passwords,
    APP_EVENTS,
  ) {
    'ngInject';

    this.$q = $q;
    this.$location = $location;
    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.appSession = appSession;
    this.passwords = passwords;
    this.APP_EVENTS = APP_EVENTS;
    this.removeOpenSubscription = this.appEvents.on(
      this.APP_EVENTS.settings.open,
      () => this.openModal(),
    );

    this.userName = '';
    this.userEmail = '';
    this.open = false;
    this.modalTitle = 'Settings';
    this.loading = false;
    this.error = '';
  }
  $onDestroy() {
    this.removeOpenSubscription();
  }
  openModal() {
    const session = this.appSession.getSession().user;
    this.userName = session.name;
    this.userEmail = session.email;
    this.open = true;
  }
  closeModal() {
    this.appEvents.emit(this.APP_EVENTS.createUser.close);
    this.open = false;
    this.error = '';
  }
  saveModal(name, email, currentPassword, newPassword, confirmNewPassword) {
    let result;
    if (this.loading) {
      result = this.$q.reject(new Error('The settings are already being updated'));
    } else {
      this.loading = true;
      this.error = '';
      result = this.appSession.updateSettings(
        name,
        email,
        currentPassword,
        newPassword,
        confirmNewPassword,
      )
      .then(() => {
        this.appEvents.emit(this.APP_EVENTS.settings.save, this.appSession.getSession().user);
        this.closeModal();
      })
      .catch((error) => {
        if (error.message) {
          this.error = error.message;
        } else {
          this.appErrorHandler.handle(error, 'There was an error while update the settings');
        }
      })
      .then(() => {
        this.loading = false;
      });
    }

    return result;
  }
  validatePassword(password) {
    return this.passwords.validate(password);
  }
}

export default {
  controller: SettingsContainer,
  template: `
    <modal-wrapper
      ng-if="$ctrl.open"
      modal-title="$ctrl.modalTitle"
      on-close="$ctrl.closeModal()"
      full-height="true"
    >
      <settings-form
        loading="$ctrl.loading"
        error="$ctrl.error"
        user-name="$ctrl.userName"
        user-email="$ctrl.userEmail"
        validate-password="$ctrl.validatePassword(password)"
        on-save="$ctrl.saveModal(
          name,
          email,
          currentPassword,
          newPassword,
          confirmNewPassword
        )"
        on-cancel="$ctrl.closeModal()"
      ></settings-form>
    </modal-wrapper>
  `,
};
